import { REPORT_PRESETS, type ReportPresetKey } from '@servwell/shared';
import { PressedGroup } from '../ui/PressedGroup';

/** The presets as the group's options: their keys and their names. */
const PERIOD_OPTIONS = REPORT_PRESETS.map((p) => ({ value: p.key, label: p.label }));

/**
 * The period presets every report offers (This month … Last 12 months), as one row of toggle
 * buttons (`PressedGroup`). Shared by the Reports page and the Revenue page so the two cannot
 * drift on what a period is called or how the chosen one is marked. The presets resolve to
 * dates elsewhere, in the shop's zone (`presetRange`); this only picks one.
 */
export function PeriodPresets({
  value,
  onChange,
}: {
  value: ReportPresetKey;
  onChange: (next: ReportPresetKey) => void;
}) {
  return (
    <PressedGroup
      label="Period"
      options={PERIOD_OPTIONS}
      value={value}
      onChange={onChange}
    />
  );
}
